import React from 'react'
import { Box, TextField, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'

export const InitiateReturnForm = ({ errors, control }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Required fields are marked with *
        </Typography>
      </Box>

      <Controller
        name="vehicleId"
        control={control}
        rules={{ required: 'Vehicle ID is required' }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Vehicle ID *"
            margin="normal"
            disabled
            error={!!errors?.vehicleId}
            helperText={errors?.vehicleId?.message as string}
          />
        )}
      />

      <Controller
        name="customerId"
        control={control}
        rules={{ required: 'Customer ID is required' }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Customer ID *"
            margin="normal"
            disabled
            error={!!errors?.customerId}
            helperText={errors?.customerId?.message as string}
          />
        )}
      />

      <Controller
        name="subscriptionId"
        control={control}
        rules={{ required: 'Subscription ID is required' }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Subscription ID *"
            margin="normal"
            disabled
            error={!!errors?.subscriptionId}
            helperText={errors?.subscriptionId?.message as string}
          />
        )}
      />

      <Controller
        name="vin"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="VIN"
            margin="normal"
            error={!!errors?.vin}
            helperText={errors?.vin?.message as string}
          />
        )}
      />

      <Controller
        name="odometerReading"
        control={control}
        rules={{
          required: 'Odometer reading is required',
          min: { value: 0, message: 'Odometer reading must be positive' }
        }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Odometer Reading (miles) *"
            margin="normal"
            type="number"
            error={!!errors?.odometerReading}
            helperText={errors?.odometerReading?.message as string}
          />
        )}
      />

      <Controller
        name="returnTime"
        control={control}
        rules={{ required: 'Return time is required' }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Return Time *"
            margin="normal"
            type="datetime-local"
            error={!!errors?.returnTime}
            helperText={errors?.returnTime?.message as string}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
      />
      <Controller
        name="missingAssetsAmount"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Missing Assets Amount (cents)"
            margin="normal"
            type="number"
            error={!!errors?.missingAssetsAmount}
            helperText={errors?.missingAssetsAmount?.message as string}
          />
        )}
      />

      <Controller
        name="initialDamagesAmount"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Initial Damages Amount (cents)"
            margin="normal"
            type="number"
            error={!!errors?.initialDamagesAmount}
            helperText={errors?.initialDamagesAmount?.message as string}
          />
        )}
      />

      <Controller
        name="miscellaneous"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label="Miscellaneous Notes"
            margin="normal"
            multiline
            rows={3}
            error={!!errors?.miscellaneous}
            helperText={errors?.miscellaneous?.message as string}
          />
        )}
      />
    </Box>
  )
}
